var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M47.9928 9.42718L24.1595 18.3538C19.6095 20.0872 15.8828 25.4605 15.8828 30.3572V65.4572C15.8828 68.9672 18.1795 73.6038 20.9961 75.6838L44.8295 93.4938C49.0328 96.6572 55.9228 96.6572 60.1261 93.4938L83.9595 75.6838C86.7761 73.5605 89.0728 68.9672 89.0728 65.4572V30.3572C89.0728 25.5038 85.3462 20.0872 80.7962 18.3972L56.9628 9.47051C54.5361 8.51718 50.4628 8.51718 47.9928 9.42718Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6924 62.1635C45.8691 62.1635 45.0457 61.8602 44.3957 61.2102L37.4191 54.2335C36.1624 52.9768 36.1624 50.8969 37.4191 49.6402C38.6757 48.3835 40.7557 48.3835 42.0124 49.6402L46.6924 54.3202L63.0291 37.9835C64.2857 36.7268 66.3657 36.7268 67.6224 37.9835C68.8791 39.2402 68.8791 41.3202 67.6224 42.5769L48.9891 61.2102C48.3391 61.8602 47.5157 62.1635 46.6924 62.1635Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon4);
export default __webpack_public_path__ + "static/media/about_icon_4.a5800672548ddb069d30193a0015d0df.svg";
export { ForwardRef as ReactComponent };